import { FeatureCollection, Point } from 'src/common-services'

export type StatePropertyOwner = {
  name: string
  address: string
}

export enum TransactionType {
  Purchase = 'purchase',
  Sale = 'sale',
}

export type StateProperty = {
  transactionType: TransactionType
  address: string
  apn: string
  price: number
  date: string
  owners: StatePropertyOwner[]
}

export type StatesProperties = Record<string, FeatureCollection<Point, StateProperty>>

export type TransactionsSummary = {
  total: number
  count: number
}

export type StateSummary = {
  state: string
  code: string
  total: number
  purchases: TransactionsSummary
  sales: TransactionsSummary
  percentage: number
  totalParcels: number // temporary
}

export type StatesSummaries = Record<string, StateSummary>
